/**
 * Shared rebate deal card rendering for homepage and /pages/rebates catalog.
 */
(function (global) {
  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s || "";
    return d.innerHTML;
  }

  function parseAmountNum(amount, badgeText) {
    var raw = amount || badgeText || "";
    var m = String(raw).match(/\$(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function amountLabel(amount, badgeText) {
    if (amount && /^\$/.test(amount)) return amount.replace(/^\$/, "");
    var m = String(badgeText || "").match(/\$(\d+)/);
    return m ? m[1] : "";
  }

  function rebateMethod(rebate) {
    if (rebate.methodLabel) return rebate.methodLabel;
    var badge = (rebate.badgeText || "").toLowerCase();
    if (badge.indexOf("mail-in") >= 0 && badge.indexOf("online") >= 0) return "Mail-in/Online";
    if (badge.indexOf("mail-in") >= 0) return "Mail-in";
    if (badge.indexOf("online") >= 0) return "Online";
    return "Rebate";
  }

  function formatEnds(iso) {
    if (!iso) return "";
    try {
      var d = new Date(iso + "T12:00:00");
      return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
    } catch (e) {
      return "";
    }
  }

  function formatTierModels(tier, vendor, tierIndex, tierCount) {
    if (tier.models && tier.models.length) return tier.models.join(", ");
    if (vendor) {
      if (tierCount === 1) return "All " + vendor + " tires";
      return "All other " + vendor + " tires";
    }
    return "All eligible models";
  }

  function groupKey(rebate) {
    return [
      (rebate.vendor || "").toLowerCase(),
      rebate.endsAt || "",
      rebate.url || rebate.rebateUrl || "",
      rebate.isEnded ? "1" : "0",
    ].join("|");
  }

  function groupRebates(rebates) {
    var groups = {};
    rebates.forEach(function (r) {
      var key = groupKey(r);
      if (!groups[key]) {
        groups[key] = {
          vendor: (r.vendor || "").trim(),
          endsAt: r.endsAt,
          url: r.url || r.rebateUrl,
          logoUrl: r.logoUrl,
          isEnded: Boolean(r.isEnded),
          methods: {},
          tiers: [],
        };
      }
      var g = groups[key];
      if (r.logoUrl && !g.logoUrl) g.logoUrl = r.logoUrl;
      if (r.isEnded) g.isEnded = true;
      if (r.methodLabel) g.methodLabel = r.methodLabel;
      g.methods[rebateMethod(r)] = true;
      if (Array.isArray(r.tiers) && r.tiers.length) {
        r.tiers.forEach(function (tier) {
          g.tiers.push({
            amount: tier.amount,
            amountNum: tier.amountNum != null ? tier.amountNum : parseAmountNum(tier.amount, ""),
            amountLabel: tier.amountLabel || amountLabel(tier.amount, ""),
            models: Array.isArray(tier.models) ? tier.models.filter(Boolean) : [],
          });
        });
      } else {
        g.tiers.push({
          amount: r.amount,
          amountNum: r.maxAmountNum != null ? r.maxAmountNum : parseAmountNum(r.amount, r.badgeText),
          amountLabel:
            r.maxAmountLabel || amountLabel(r.amount, r.badgeText),
          models: Array.isArray(r.models) ? r.models.filter(Boolean) : [],
        });
      }
      if (r.maxAmountLabel) {
        g.maxAmountLabel = r.maxAmountLabel;
        g.maxAmountNum = r.maxAmountNum != null ? r.maxAmountNum : parseAmountNum("$" + r.maxAmountLabel, "");
      }
    });

    return Object.keys(groups)
      .map(function (key) {
        var g = groups[key];
        if (!g.tiers.length && g.maxAmountLabel) {
          g.tiers.push({
            amount: "$" + g.maxAmountLabel,
            amountNum: g.maxAmountNum || parseAmountNum("$" + g.maxAmountLabel, ""),
            amountLabel: g.maxAmountLabel,
            models: [],
          });
        }
        g.tiers.sort(function (a, b) {
          return b.amountNum - a.amountNum;
        });
        if (!g.maxAmountLabel && g.tiers.length) {
          g.maxAmountNum = g.tiers[0].amountNum;
          g.maxAmountLabel = g.tiers[0].amountLabel;
        }
        var methods = Object.keys(g.methods);
        if (!g.methodLabel) {
          if (methods.indexOf("Mail-in") >= 0 && methods.indexOf("Online") >= 0) {
            g.methodLabel = "Mail-in/Online";
          } else if (methods.length) {
            g.methodLabel = methods[0];
          } else {
            g.methodLabel = "Rebate";
          }
        }
        return g;
      })
      .sort(function (a, b) {
        if (a.isEnded !== b.isEnded) return a.isEnded ? 1 : -1;
        if (a.isEnded && b.isEnded) {
          return (b.endsAt || "").localeCompare(a.endsAt || "");
        }
        return (a.vendor || "").localeCompare(b.vendor || "");
      });
  }

  function methodBadgeLabel(group) {
    if (group.isEnded) return "Ended";
    var label = group.methodLabel || "Rebate";
    if (label === "Mail-in") return "Mail-in rebate";
    if (label === "Online") return "Online rebate";
    return label;
  }

  function headlineHtml(group) {
    var vendor = group.vendor || "select";
    if (group.maxAmountLabel) {
      return "Save up to $" + esc(group.maxAmountLabel) + " on " + esc(vendor) + " tires";
    }
    return "Rebate on " + esc(vendor) + " tires";
  }

  function logoHtml(group, logos) {
    var vendor = group.vendor || "";
    var logoUrl = group.logoUrl || (vendor && logos && logos[vendor]) || "";
    if (logoUrl) {
      return (
        '<div class="home-deals__logo">' +
        '<img src="' +
        esc(logoUrl) +
        '" alt="' +
        esc(vendor || "Brand") +
        '" loading="lazy" width="120" height="48">' +
        "</div>"
      );
    }
    if (!vendor) return "";
    return (
      '<div class="home-deals__logo home-deals__logo--text" data-tire-brand-fallback data-vendor="' +
      esc(vendor) +
      '"><span class="home-deals__logo-fallback">' +
      esc(vendor) +
      "</span></div>"
    );
  }

  function tiersHtml(group) {
    if (!group.tiers.length) return "";
    return group.tiers
      .map(function (tier, index) {
        var label = tier.amountLabel || String(tier.amountNum || "");
        var models = formatTierModels(tier, group.vendor, index, group.tiers.length);
        if (!label) {
          return '<p class="home-deals__tier">' + esc(models) + "</p>";
        }
        return (
          '<p class="home-deals__tier">' +
          '<strong class="home-deals__tier-amount">$' +
          esc(label) +
          ":</strong> " +
          esc(models) +
          "</p>"
        );
      })
      .join("");
  }

  function renderCard(group, logos, options) {
    options = options || {};
    var ends = formatEnds(group.endsAt);
    var href = group.url || "";
    var tiers = tiersHtml(group);
    var ended = Boolean(group.isEnded);
    var cardClass = "home-deals__card" + (ended ? " home-deals__card--ended" : "");
    var badgeClass = "home-deals__badge" + (ended ? " home-deals__badge--ended" : "");
    var claimLabel = ended ? "View claim form" : "Claim rebate";
    var claimBtnClass = ended ? "home-deals__cta home-deals__cta--secondary" : "home-deals__cta";
    var claimBtn = href
      ? '<a class="' +
        claimBtnClass +
        '" href="' +
        esc(href) +
        '" target="_blank" rel="noopener noreferrer">' +
        esc(claimLabel) +
        "</a>"
      : ended
        ? ""
        : '<a class="home-deals__cta home-deals__cta--secondary" href="/pages/tires">Shop tires</a>';
    var dateLine = ends
      ? '<p class="home-deals__ends">' + (ended ? "Ended " : "Ends ") + esc(ends) + "</p>"
      : ended
        ? '<p class="home-deals__ends home-deals__ends--ended">Ended</p>'
        : "";

    return (
      '<article class="' +
      cardClass +
      '">' +
      '<span class="' +
      badgeClass +
      '">' +
      esc(methodBadgeLabel(group)) +
      "</span>" +
      logoHtml(group, logos) +
      '<div class="home-deals__body">' +
      '<h3 class="home-deals__headline">' +
      headlineHtml(group) +
      "</h3>" +
      dateLine +
      (tiers
        ? '<details class="home-deals__eligible">' +
          '<summary class="home-deals__eligible-toggle">View eligible tires</summary>' +
          '<div class="home-deals__levels">' +
          tiers +
          "</div></details>"
        : "") +
      claimBtn +
      "</div></article>"
    );
  }

  function renderCatalogSection(title, groups, logos, options, ended) {
    if (!groups.length) return "";
    return (
      '<div class="home-deals__catalog-section' +
      (ended ? " home-deals__catalog-section--ended" : "") +
      '">' +
      '<div class="home-deals__catalog-section-head">' +
      '<h2 class="home-deals__catalog-section-title">' +
      esc(title) +
      "</h2>" +
      '<span class="home-deals__catalog-section-count" aria-hidden="true">' +
      groups.length +
      "</span>" +
      "</div>" +
      '<div class="home-deals__grid">' +
      groups
        .map(function (g) {
          return renderCard(g, logos, options);
        })
        .join("") +
      "</div></div>"
    );
  }

  function renderRebateGrid(grid, rebates, logos, options) {
    options = options || {};
    logos = logos || {};
    if (!grid) return;
    if (!rebates.length) {
      grid.innerHTML =
        '<p class="home-deals__empty">' +
        esc(options.emptyMessage || "Check back for seasonal rebates and promotions.") +
        "</p>";
      return;
    }
    var groups = options.preGrouped ? rebates : groupRebates(rebates);
    if (options.splitByStatus) {
      var active = groups.filter(function (g) {
        return !g.isEnded;
      });
      var ended = groups.filter(function (g) {
        return g.isEnded;
      });
      var statsHtml =
        '<div class="home-deals__catalog-stats" role="status">' +
        '<span class="home-deals__catalog-stat home-deals__catalog-stat--active">' +
        '<span class="home-deals__catalog-stat-value">' +
        active.length +
        "</span> active" +
        "</span>" +
        (ended.length
          ? '<span class="home-deals__catalog-stat home-deals__catalog-stat--ended">' +
            '<span class="home-deals__catalog-stat-value">' +
            ended.length +
            "</span> recently ended" +
            "</span>"
          : "") +
        "</div>";
      grid.innerHTML =
        statsHtml +
        renderCatalogSection("Current rebates", active, logos, options, false) +
        renderCatalogSection("Recently ended", ended, logos, options, true);
    } else {
      grid.innerHTML = groups
        .map(function (g) {
          return renderCard(g, logos, options);
        })
        .join("");
    }
    if (global.applyTireBrandLogos) global.applyTireBrandLogos(grid);
  }

  function loadLogos() {
    if (global.SpecrTireBrandLogos && global.SpecrTireBrandLogos.load) {
      return global.SpecrTireBrandLogos.load();
    }
    return Promise.resolve({});
  }

  global.SpecrRebateDeals = {
    esc: esc,
    groupRebates: groupRebates,
    renderCard: renderCard,
    renderRebateGrid: renderRebateGrid,
    loadLogos: loadLogos,
  };
})(typeof window !== "undefined" ? window : globalThis);
